import React from 'react'
import Conclusion from './FeaturesComponents/Conclusion'
import Consultation from './FeaturesComponents/Consultation'
import CreateYourbox from './FeaturesComponents/CreateYourbox'
import SelfCareProducts from './FeaturesComponents/SelfCareProducts'
import TrackMood from './FeaturesComponents/TrackMood'
import TrackYourPeriod from './FeaturesComponents/TrackYourPeriod'
import WhatMakesUsDifferent from './FeaturesComponents/WhatMakesUsDifferent'



export default function Features() {
  return (
    <>
    <WhatMakesUsDifferent/>   
    <SelfCareProducts/>
    <TrackMood/>
    <TrackYourPeriod/>
    <Consultation/>
    <CreateYourbox/>
    <Conclusion/>  

    </>
  )
}
